/**
 * get tracking ids from cookies to identify user
 */

export const getTrackingIds = () => {
  const getCookie = (name) => {
    const v = document.cookie.match(`(^|;) ?${name}=([^;]*)(;|$)`);
    return v ? v[2] : null;
  };

  const urlParams = new URLSearchParams(window.location.search);

  // --- Client ID Analytics ---
  const gaCookie = getCookie('_ga');
  let ga_client_id = null;
  if (gaCookie) {
    const parts = gaCookie.split('.');
    if (parts.length >= 2) {
      ga_client_id = parts.slice(-2).join('.');
    }
  }

  // --- Google Ads (gcl_aw) ---
  const gclAwCookie = getCookie('_gcl_aw');
  const gclid = urlParams.get('gclid') || (gclAwCookie ? gclAwCookie.split('.').pop() : null);

  // --- Facebook (_fbc) ---
  const fbcCookie = getCookie('_fbc');
  const fbclid = urlParams.get('fbclid') || (fbcCookie ? fbcCookie.split('.').pop() : null);

  return {
    gclid,
    gcl_au: getCookie('_gcl_au'),
    ga_client_id,
    fbclid,
    fbp: getCookie('_fbp'),
    ttclid: urlParams.get('ttclid') || getCookie('ttclid'),
  };
};
